export default {
  OrderLists:[],                //订单列表
  QuotationLists:[],            //报价列表
  OrderDetail:{                 //订单详情
    meetArr:[],
    roomArr:[],
    actiArr:[],
    payList:[],
    add_need_arr:[],            //新增需求列表
    hotelLists:[],
    contactInfo:{},
    my_offer:{}
  },
  Userlist:0,                   //采购商旗下人员
  Hotellist:0,                   //酒店旗下酒店
  TotalOrder:0,                 //查询的订单总数
  HotterOfferLists:[],          //采购商、管理员查看住宿订单报价酒店列表
  noChoose: 0,                  //采购商订单未选中酒店
  choose: [],                   //选中的酒店列表
  SetRoomPriceArr:[],           //报价、还价时的房间价格列表
  SetMeetPriceArr:[],           //报价、还价时的会议室价格列表
  travelChoose:[],              //采购商已选择的酒店列表
  orderPostPre:{
    contact:{},
    order:{}
  },              //采购商发布、重发订单，管理员编辑订单时获取的订单信息
  orderMatchResult:{            //匹配酒店列表
    hotelList:[],
    matchInfo:{
      star:''
    },
  },
  PayQRCode:'',                //订单生成支付二维码
  CardInfoList:[],             //年卡信息
  OrderNumInfo:{},             //待处理及相应状态的订单总数
  //************ 修改订单状态 ****************/
  StoreMeetList:[],            //修改时会议室列表信息
  StoreRoomList:[],            //修改时房间列表信息
  confirmid:localStorage.getItem('confirmid')||'',              //确认订单酒店信息
}
